module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"New Campaign":"Neue Kampagne","Show filters":"Filter anzeigen","Hide filters":"Filter verbergen","Campaign list could not be fetched.":"Kampagnenliste konnte nicht abgerufen werden."}}')
  delete Component.options._Ctor
}
